import size from "lodash/size";
import snakeCase from "lodash/snakeCase";
import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router";

import iconSprite from "../../../../images/img/chat/icons.svg";
import SvgIcon from "../common/SvgIcon";

const MinimizedViewOpenQuestions = ({ allOpenQuestionsId, pathToMaximize }) => {
    const label = i18n.t("rtm.text.active_questions", {
        questions: size(allOpenQuestionsId),
    });
    return (
        <Link className="MinimizedView MinimizedView--OpenQuestions" to={pathToMaximize}>
            <SvgIcon className="MinimizedView__icon svg-icon" id="icon-chat" src={iconSprite} />
            {label.split("\n").map((text, key) => (
                <span key={snakeCase(text)} className="MinimizedView__label">
                    {text}
                    {label.split("\n").length !== key + 1 && <br />}
                </span>
            ))}
        </Link>
    );
};

MinimizedViewOpenQuestions.propTypes = {
    allOpenQuestionsId: PropTypes.arrayOf(PropTypes.string).isRequired,
    pathToMaximize: PropTypes.string.isRequired,
};

export default MinimizedViewOpenQuestions;
